import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { toast } from '@brimostech/ui';
import { ApiError } from './api-client';

export function errorMessage(
  error: unknown,
  fallback = 'Algo deu errado. Tente novamente.',
): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

/** Maps API field errors onto the form; returns true when at least one field was marked. */
export function applyFieldErrors<T extends FieldValues>(
  error: unknown,
  form: UseFormReturn<T>,
): boolean {
  if (!(error instanceof ApiError) || error.details.length === 0) return false;
  let applied = false;
  for (const detail of error.details) {
    if (!detail.path) continue;
    form.setError(detail.path as Path<T>, { type: 'server', message: detail.message });
    applied = true;
  }
  return applied;
}

/** Shows a toast for an API error unless it was mapped onto a form field. */
export function reportError<T extends FieldValues>(error: unknown, form?: UseFormReturn<T>): void {
  if (form && applyFieldErrors(error, form)) return;
  toast.error(errorMessage(error));
}
